export const AXIOSLOADING = 'AXIOSLOADING';


// WEBPACK FOOTER //
// ./src/store/motation_type.js